import photos from "../../../fakeApi/photos";
const state = { photos: [] };

const getters = {
  allPhotos: state => state.photos.data
};
const actions = {
  async fetchPhotos({ commit }) {
    commit("setPhotos", photos);
  }
};

const mutations = {
  setPhotos: (state, photos) => (state.photos = photos)
};

export default {
  state,
  getters,
  actions,
  mutations
};
